import React from 'react'
import Layout from '../Layout/Layout';
import ContactTable from './ContactTable';
import { VStack } from '@chakra-ui/react';

const Contact = () => {
  return (
      <VStack
        h="100%"
        spacing={2}
        justifyContent={"space-between"}
        borderRadius="md"
      >
        <ContactTable />
      </VStack>
  );
}

export default Contact